<div class="background">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <div *ngIf="!isLoading" class="content">
    <ng-content></ng-content>
  </div>
</div>
